import React from "react";
import SEOHead from "../../components/SEOHead";
import { AdsLandingLayout } from "../../stories/adsLanding/AdsLandingLayout";

const PAGE_URL = "https://www.olzoom.com/ads";
const PAGE_TITLE =
  "네이버 상품 순위 올려주는 셀프마케팅 올려줌 | 10일 무료 테스트";
const PAGE_DESCRIPTION =
  "네이버 상품 순위를 올려주는 셀프마케팅 올려줌. 유입플이 아닌 자사 리워드앱 실제 사용자로 쇼핑 검색 1페이지 노출을 만들고, 무료 진단과 10일 무료 테스트로 매출 변화를 확인하세요.";
const PAGE_KEYWORDS =
  "네이버 상품 순위, 네이버 쇼핑 순위 올리는 방법, 스마트스토어 순위, 셀프마케팅, 리워드, 유입플, 10일 무료 테스트, 올려줌";
const PAGE_OG_IMAGE = "https://www.olzoom.com/logo.png";

const structuredData = {
  "@context": "https://schema.org",
  "@type": "WebPage",
  name: PAGE_TITLE,
  description: PAGE_DESCRIPTION,
  url: PAGE_URL,
  inLanguage: "ko-KR",
  isPartOf: {
    "@type": "WebSite",
    name: "올려줌",
    url: "https://www.olzoom.com/",
  },
  about: {
    "@type": "Service",
    name: "네이버 상품 순위 리워드 셀프마케팅",
    description: PAGE_DESCRIPTION,
    provider: {
      "@type": "Organization",
      name: "올려줌",
      url: "https://www.olzoom.com/",
    },
    areaServed: "KR",
  },
  offers: {
    "@type": "Offer",
    name: "10일 무료 테스트",
    description: "무료 진단과 함께하는 10일 무료 테스트",
    price: "0",
    priceCurrency: "KRW",
  },
};

const AdsLandingPage = () => (
  <>
    <SEOHead
      title={PAGE_TITLE}
      description={PAGE_DESCRIPTION}
      keywords={PAGE_KEYWORDS}
      canonicalUrl={PAGE_URL}
      ogImage={PAGE_OG_IMAGE}
      structuredData={structuredData}
    />
    <AdsLandingLayout />
  </>
);

export default AdsLandingPage;
